export const dateObjToYMD = (dateObj) =>
  new Date(dateObj).toLocaleDateString('en-CA', {
    timeZone: 'Europe/London',
  });
